"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ingDict_1 = require("./data/ingDict");

exports.default = ingDict_1.default;
exports.CATEGORY = ingDict_1.CATEGORY;